import React from 'react';
import { X, Bell } from 'lucide-react';
import { IS_MAGIC_TEAM } from '../lib/brand';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NotificationPopup = ({ notification, onClose }) => {
  if (!notification) return null;

  const imageUrl = notification.image_path ? `${API}/thumbnails/${notification.image_path}` : null;

  if (!IS_MAGIC_TEAM && notification.is_banner && imageUrl) {
    return (
      <div
        className="fixed inset-0 z-[95] flex items-start justify-center bg-black/60 pt-20 px-4 animate-fade-in"
        data-testid="notification-popup-banner"
      >
        <div className="w-full max-w-sm bg-white rounded-2xl shadow-2xl overflow-hidden">
          <img
            src={imageUrl}
            alt={notification.title}
            className="w-full aspect-[2.5/1] object-cover bg-zinc-100"
          />
          <div className="p-4">
            <p className="font-semibold text-zinc-900">{notification.title}</p>
            {notification.body && (
              <p className="text-zinc-600 text-sm mt-1">{notification.body}</p>
            )}
            <button
              type="button"
              onClick={onClose}
              className="mt-4 w-full py-2.5 rounded-full border border-zinc-300 text-zinc-700 font-medium hover:bg-zinc-50 transition-colors"
              data-testid="notification-popup-close"
            >
              Chiudi
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="fixed top-[72px] left-2 right-2 md:left-1/2 md:right-auto md:-translate-x-1/2 z-[90] md:w-[90vw] md:max-w-md animate-slide-down cursor-pointer pointer-events-auto"
      onClick={onClose}
      data-testid="notification-popup"
    >
      <div className="bg-white border-2 border-[#D4AF37] rounded-2xl shadow-2xl p-4 flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0">
          <Bell className="w-5 h-5 text-[#D4AF37]" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-zinc-900 text-sm">{notification.title}</p>
          <p className="text-zinc-600 text-sm mt-1 line-clamp-3">{notification.body}</p>
        </div>
        <button
          onClick={(e) => { e.stopPropagation(); onClose(); }}
          className="text-zinc-400 hover:text-zinc-700 transition-colors flex-shrink-0"
          data-testid="notification-popup-close"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default NotificationPopup;
